import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const IconWrapper = styled(Box)
    .withConfig({ displayName: 'IconWrapper' })
    .attrs((props) => ({
        position: 'absolute',
        zIndex: 1,
        p: 0.25,
        borderRadius: 1,
        background: 'var(--control-secondary-blur-background)',
        ...props,
    }))``;

export const MonetizationIconWrapper = styled(Box)
    .withConfig({ displayName: 'MonetizationIconWrapper' })
    .attrs((props) => ({
        position: 'absolute',
        zIndex: 1,
        p: '5px',
        width: 24,
        height: 24,
        backgroundColor: 'var(--always-white)',
        borderRadius: 1,
        ...props,
    }))``;
